import WidgetPlaceholder from './WidgetPlaceholder';

export default WidgetPlaceholder;
